import { render, staticRenderFns } from "./billForPreson.vue?vue&type=template&id=12ddae4c&scoped=true"
import script from "./billForPreson.vue?vue&type=script&lang=js"
export * from "./billForPreson.vue?vue&type=script&lang=js"
import style0 from "./billForPreson.vue?vue&type=style&index=0&id=12ddae4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ddae4c",
  null
  
)

export default component.exports